import { BaseProfile } from '../../profile-settings/models/base-profile';
import { Account } from './account';

/**  Holds the information for a signup request */
export class SignupRequest extends BaseProfile {
  /** Account to be created */
  Account = new Account();
  /** Indicates if the user accepts the privacy policy */
  AcceptsPrivacyPolicy: boolean;
  /** Indicates if the user accepts the information */
  AcceptsInformation: boolean;
  /** Saves the email of the applicant */
  Password: string;
  Email: string;
  Nif: string;
}
